export const TEXT_TYPES = {
  LINK: 'LINK',
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UL: 'unordered-list-item',
  OL: 'ordered-list-item',
}
